export default {
      id: "faibles-passages-nuageux-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#faibles-passages-nuageux-usage",
      toString: function () {
        return this.url;
      }
    }